import { createClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  throw new Error(
    "VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY 환경변수가 없습니다. .env.local 확인."
  );
}

export const supabase = createClient(url, anonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true, // magic link callback
  },
});

// AI model 매핑 — 모든 케이스가 Opus 4.7 사용 (2026-05-07 짱샘 결정).
// 패키지 결제 모델로 전환 후 plan_tier는 잔존 컬럼이지만, 짱샘 검토 정밀도가
// 핵심 차별화이므로 모델은 항상 최고 품질로 통일한다.
export const MODEL_FOR_PLAN = {
  trial: "opus",
  basic: "opus",
  pro: "opus",
};

export const CLAUDE_MODEL_ID = {
  haiku: "claude-haiku-4-5-20251001",
  opus: "claude-opus-4-7",
};
